var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 384V352C256 322.581 279.915 298.667 309.333 298.667H320V288C320 270.357 334.357 256 352 256H416C433.643 256 448 270.357 448 288V298.667H458.667C488.085 298.667 512 322.581 512 352V384H256ZM405.333 426.667V448H362.667V426.667H256V512H512V426.667H405.333ZM213.333 512H0V64C0 28.7147 28.7147 0 64 0H277.333C312.619 0 341.333 28.7147 341.333 64V214.144C314.837 217.963 292.779 235.669 282.901 259.712C242.773 271.211 213.333 308.224 213.333 352V512ZM192 149.333H256V106.667H192V149.333ZM192 234.667H256V192H192V234.667ZM149.333 362.667H85.3333V405.333H149.333V362.667ZM149.333 277.333H85.3333V320H149.333V277.333ZM149.333 192H85.3333V234.667H149.333V192ZM149.333 106.667H85.3333V149.333H149.333V106.667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/Business.43af112be7d9b37acb3549f140ebf449.svg";
export { ForwardRef as ReactComponent };